import { render, staticRenderFns } from "./SessionExpirationDialog.vue?vue&type=template&id=06704335&scoped=true"
import script from "./SessionExpirationDialog.vue?vue&type=script&lang=js"
export * from "./SessionExpirationDialog.vue?vue&type=script&lang=js"
import style0 from "./SessionExpirationDialog.vue?vue&type=style&index=0&id=06704335&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06704335",
  null
  
)

export default component.exports